import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import styled from 'styled-components';

export const StyledSortPanel = styled.div`
  width: 100%;
  height: calc(100% - 42px);
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  .answers {
    gap: 20px;
    display: grid;
    grid-template-columns: repeat(
      ${(props) => (props.optionsLength == 3 ? 3 : 4)},
      1fr
    );

    .answer {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      line-height: 1.5;
      position: relative;

      &.not-playing {
        .answer-text {
          color: ${Colors.lighterGray};
        }
      }

      ${(props) =>
        props.optionsLength == 2
          ? `
            &:nth-child(1) {  
              grid-column: 2;
            }
              &:nth-child(2) {  
              grid-column: 3;
            } 
          `
          : ''}

      .answer-text {
        flex: 1;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border: 1px solid ${Colors.border};
        border-bottom: none;
        padding: 18px 8px;
        background: white;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: ${font.weightBold};
        font-size: 16px;
        color: ${Colors.primary};
        text-align: center;
      }
    }
  }

  .options {
    display: grid;
    grid-template-columns: repeat(
      ${(props) => (props.optionsLength == 3 ? 3 : 4)},
      1fr
    );
    gap: 15px 20px;

    .option-placeholder,
    .option {
      width: 100%;

      ${(props) =>
        props.optionsLength == 2
          ? `
            &:nth-child(1) {  
              grid-column: 2;
            }
              &:nth-child(2) {  
              grid-column: 3;
            } 
          `
          : ''}
    }
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${Colors.backgroundPaleBlue}dd;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100;

    h3 {
      margin-top: 40px;
      color: ${Colors.primary};
      font-weight: ${font.weightBold};
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    padding: 5px;
    gap: 5px;

    .options,
    .answers {
      gap: 5px;
    }
    .answers .answer .answer-text {
      font-size: 14px;
    }
  }
`;
